import { atom } from 'jotai';
import type { Plan } from 'app/types/plan';
import { atomWithReset, useResetAtom } from 'jotai/utils';

export const userPlanAtom = atomWithReset<Plan[] | null>(null);
export const hasExpiredPlanAtom = atom((get) => {
  const plans = get(userPlanAtom);
  const activePlan = plans?.[0];

  if (activePlan?.expiresAt) {
    return new Date(activePlan.expiresAt).getTime() < new Date().getTime();
  }

  return false;
});

export function useResetPlanAtoms() {
  const resetUserPlan = useResetAtom(userPlanAtom);
  return () => {
    resetUserPlan();
  };
}
